import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

import { routes } from './app.routes';
import { httpInterceptorProviders } from './core/http-interceptors';

// Core services
import { AuthService } from './core/auth/auth.service';
import { ProfileService } from './core/auth/profile.service';
import { NavbarService } from './core/navbar/navbar.service';
import { DomainService } from './core/domain/domain.service';
import { GlobalErrorHandlerService } from './core/error-handler/global-error-handler.service';
import { HttpErrorService } from './core/http-error/http-error.service';
import { ContextTypeGuard } from './core/guards/context-type.guard';
import { ProfileGuard } from './core/guards/profile.guard';
import { DomService } from './core/dom/dom.service';
import { GridService } from './core/grid/grid.service';
import { FlashMessageService } from './core/flash-message/flash-message.service';
import { WindowRef } from './core/domain/window-ref';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    // HTTP Interceptors
    httpInterceptorProviders,
    
    // Core services
    AuthService,
    ProfileService,
    GlobalErrorHandlerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    DomainService,
    HttpErrorService,
    NavbarService,
    ContextTypeGuard,
    ProfileGuard,
    DomService,
    GridService,
    FlashMessageService,
    WindowRef,
    CookieService,
  ]
};
